// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wrk40","title":"Header_title__3HjQS","side":"Header_side__1mepg"};